export const SharePricingDialogPage = {
  PRICE_TIERS: 0,
  PRICE_TIER_LINK: 1,
  PRICE_TIER_LINK_DEACTIVATE: 2,
};

export type SharePricingSource =
  | "sidebar"
  | "customer-page"
  | "storefront-preview";
